module.exports = __webpack_public_path__ + "img/speedometer.21c0337e.svg";